import { isWithinInterval } from "date-fns";
import DateIntervalStrategy from "../DateIntervalStrategy";
import { getChartName } from "../../helpers/UtilityHelper";

export class DeliveryPerformance extends DateIntervalStrategy {

    dataList = [];
    courierList = [];

    constructor(queryParams, _api) {
        super(queryParams.groupOn, queryParams.fromDate, queryParams.toDate)
        this.groupOn = queryParams.groupOn || 'DOD';

        const keyLists = Object.keys(_api.getState().courierPerformanceApi.queries).filter(key => key.includes('getDeliveryMetrics'))
        for (const key of keyLists) {
            const originalData = _api.getState().courierPerformanceApi.queries[key]?.originalArgs
            const isFulfilled = _api.getState().courierPerformanceApi.queries[key]?.status === 'fulfilled'

            const isSameFromDate = originalData.fromDate === queryParams.fromDate
            const isSameToDate = originalData.toDate === queryParams.toDate

            if (isFulfilled && isSameFromDate && isSameToDate) {
                this.dataList = _api.getState().courierPerformanceApi.queries[key]?.data || []
            }
        }
    }

    groupByCourierId(dataList) {
        return dataList.reduce((acc, item) => {
            const courierId = item.courierId;
            if (!acc.has(courierId)) {
                acc.set(courierId, []);
            }
            acc.get(courierId)?.push(item);
            return acc;
        }, new Map())
    }

    getSumByProperty(property, dataList) {
        return dataList.reduce((acc, item) => {
            return acc + ((item[property] || 0))
        }, 0);
    }

    calculatePercentage(numerator, denominator) {
        return numerator / denominator * 100 || 0;
    }

    dataGroupByDate() {
        return this.dataList.reduce((acc, item) => {
            const date = item.awbRegisteredDay;
            if (!acc.has(date)) {
                acc.set(date, []);
            }
            acc.get(date)?.push(item);
            return acc;
        }, new Map())
    }

    getPerformaceTrend() {
        const dataGroupByDate = this.dataGroupByDate();
        const dataMaPKeys = Array.from(dataGroupByDate.keys());

        const deliveryPerformanceTrend = []

        for (const index in this.interval.slice(0, -1)) {
            const start = this.interval[index]
            const end = this.interval[+index + 1] || start

            const dataWithInInterval = dataMaPKeys
                .filter((date) => isWithinInterval(new Date(date), { start, end }))
                .map((date) => dataGroupByDate.get(date) || [])
                .flat();

            deliveryPerformanceTrend.push({
                name: getChartName({ groupOn: this.groupOn, start, end }),
                data: this.getPerformace(dataWithInInterval),
            })

        }
        return deliveryPerformanceTrend;
    }

    getPerformaceSplit(dataList) {
        const totalPickedupCount = this.getSumByProperty('totalPickedupCount', dataList)
        const totalDeliveredCount = this.getSumByProperty('totalDeliveredCount', dataList)
        const totalDeliveryAttemptedCount = this.getSumByProperty('totalDeliveryAttemptedCount', dataList)
        const deliveredInFirstAttemptCount = this.getSumByProperty('deliveredInFirstAttemptCount', dataList)
        const codDeliveredCount = this.getSumByProperty('codDeliveredCount', dataList)
        const codCount = this.getSumByProperty('codCount', dataList)
        const prepaidDeliveredCount = this.getSumByProperty('prepaidDeliveredCount', dataList)
        const prepaidCount = this.getSumByProperty('prepaidCount', dataList)
        const codPercentage = this.calculatePercentage(codCount, totalPickedupCount)

        return {
            overallDelivery: this.calculatePercentage(totalDeliveredCount, totalPickedupCount),
            firstAttemptAdherence: this.calculatePercentage(deliveredInFirstAttemptCount, totalDeliveryAttemptedCount),
            codDeliveryPercentage: this.calculatePercentage(codDeliveredCount, codCount),
            prepaidDeliveryPercentage: this.calculatePercentage(prepaidDeliveredCount, prepaidCount),
            totalPickedupCount,
            totalDeliveredCount,
            totalDeliveryAttemptedCount,
            deliveredInFirstAttemptCount,
            codDeliveredCount,
            codCount,
            prepaidDeliveredCount,
            prepaidCount,
            codPercentage
        }
    }

    getPerformace(dataList) {
        const courierWiseData = this.groupByCourierId(dataList || this.dataList);
        return Array.from(courierWiseData.entries()).reduce((acc, [courierId, dataList]) => {
            acc.set(courierId, {
                courierId,
                ...this.getPerformaceSplit(dataList)
            })
            return acc;
        }, new Map())
    }
}
